// extracted by mini-css-extract-plugin
module.exports = {"layout":"page-hero_layout__DLmpN","aboveTheFoldBg":"page-hero_aboveTheFoldBg__oAbU0","heroGraphic":"page-hero_heroGraphic__59eAS","descriptor":"page-hero_descriptor__5preg"};